export enum IsProduct {
  TM3Connect = 'isTM3Connect',
  TM3Essentials = 'isTM3Essentials',
  ProntoPortal = 'isProntoPortal',
  Click = 'isClick',
  EClinic = 'isEClinic',
  PPM = 'isPPM',
  GDS = 'isGDS',
  Caseflow = 'isCaseflow'
}
